import { BehaviorParameters } from 'rangeConfig/@types';
import { NightLightsSystem, ProductType } from '@inter-ikea-storageone/range';
import { ComponentIds } from '@inter-ikea-core/core';
import { removeProducts } from 'rangeConfig/shared/utils/removeProducts';

const removeOuterLightsFromScene = ({
  coreApi,
  rootState: {
    layout: { darkScene },
    products: { inMarket: products }
  }
}: BehaviorParameters) => {
  const outerLights = coreApi.entities.getByProductTypes([ProductType.PAX_OUTER_LIGHT]);

  if (outerLights.length > 0) {
    removeProducts(outerLights, coreApi, products);
  }

  if (darkScene) {
    const currentLightsInScene = coreApi.entities.getByComponent(ComponentIds.LIGHT_COMPONENT_ID);

    if (currentLightsInScene.length === 0) {
      coreApi.getSystem<NightLightsSystem>('NightLightsSystem')?.disable();
      coreApi.emit.onEnableNightMode(false);
    }
  }
};

export default removeOuterLightsFromScene;
